import React, { Component } from 'react';
import { Modal, Tooltip, OverlayTrigger } from 'react-bootstrap';
import CompanyDetails from './companyDetails';
import { deleteCompany } from '../../../../services/clinicPortalServices/companyServices';
import Swal from 'sweetalert2';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';

export default class EditBtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            companyId: props.data._id,
            companyName: props.data.name,
            errors: []
        };
    }

    handleShow = () => {
        this.setState({ show: true });
    };

    handleClose = () => {
        this.setState({ show: false });
    };

    handleDelete = () => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this company!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it',
            customClass: {
                container:
                    window.localStorage.getItem('appTheme') === 'Dark' &&
                    /clinic|lims/.test(window.location.pathname.split('/')[1]) &&
                    'dark-swal',
                cancelButton: 'order-1',
                confirmButton: 'order-2'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                const companyInfo = {
                    id: this.state.companyId,
                    name: this.state.companyName
                };
                deleteCompany(companyInfo).then((response) => {
                    this.props.context.componentParent.loadGridData();
                });
            }
        });
    };

    renderTooltipEdit = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Edit Company
        </Tooltip>
    );

    renderTooltipDelete = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Delete Company
        </Tooltip>
    );

    render() {
        return (
            <div>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipEdit}>
                    <button onClick={this.handleShow} className="edit-order-btn">
                        <i className="fas fa-pen"></i>
                    </button>
                </OverlayTrigger>
                {/* {
					!(/customerserviceuser/.test(getUserRole().toLowerCase())) &&
					<OverlayTrigger
						placement="top"
						delay={{ show: 50, hide: 100 }}
						overlay={this.renderTooltipDelete}
					>
						<button onClick={this.handleDelete} className="edit-order-btn">
							<i className="fas fa-trash"></i>
						</button>
					</OverlayTrigger>
				} */}
                <ModalStyled
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.show}
                    onHide={this.handleClose}
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Update Company Information</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <CompanyDetails
                            companyId={this.state.companyId}
                            context={this.props.context}
                            handleClose={this.handleClose}
                        />
                    </Modal.Body>
                </ModalStyled>
            </div>
        );
    }
}
